import { createSelector } from 'reselect';
import { RootState } from '../root-state';

export const selectProfile = createSelector(
  (state: RootState) => state.auth.profile,
  profile => profile,
);
